<template>
  <ResponsivePopoverView v-model:active="active" placement="bottom">
    <template v-slot:target>
      <ButtonView type="shaded" color="foreground" size="small" :active="active" :style="{ color: activeColor }" @click="active = true">
        <i class="fas fa-droplet fa-fw" style="font-size: 1.2em"></i>
      </ButtonView>
    </template>
    <template v-slot:body>
      <div class="d-table">
        <div class="d-table-row" v-for="(row, rowIndex) in colorOptions" :key="rowIndex">
          <div class="d-table-cell" v-for="(color, colorIndex) in row" :key="colorIndex">
            <button class="clickable" style="background: transparent; border: none" @click="editor.chain().focus().setColor(color).run(); active = false">
              <i class="fas fa-square" style="font-size: 2.5em" :style="{ 'color': color }"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center g-3 mt-4">
        <ButtonView type="normal" color="secondary" size="small" class="w-100" @click="editor.chain().focus().unsetColor().run(); active = false">
          <i class="fas fa-droplet-slash"></i>
        </ButtonView>
        <div class="position-relative d-flex justify-content-center align-items-center w-100" style="cursor: pointer">
          <input ref="picker" type="color" :value="activeColor" class="btn btn-normal w-100 h-100" :style="{ 'background-color': activeColor }" @input="editor.chain().focus().setColor($event.target.value).run()"/>
          <i class="position-absolute fas fa-eye-dropper text-foreground bg-secondary p-2 rounded-circle" style="font-size: 0.7em; pointer-events: none"></i>
        </div>
      </div>
    </template>
  </ResponsivePopoverView>
</template>

<script setup>
import ResponsivePopoverView from "../../../general/ResponsivePopoverView.vue";
import ButtonView from "../../../general/ButtonView.vue";
import {computed, ref} from "vue";

const props = defineProps({
  editor: Object
});

const active = ref(false);

const picker = ref(undefined);

const activeColor = computed(() => {
  let attributes = props.editor.getAttributes("textStyle");
  if (attributes) return attributes["color"];
  return undefined;
});

const colorOptions = [["#BFEDD2", "#FBEEB8", "#F8CAC6", "#ECCAFA", "#C2E0F4"], ["#2DC26B", "#F1C40F", "#E03E2D", "#B96AD9", "#3598DB"], ["#169179", "#E67E23", "#BA372A", "#843FA1", "#236FA1"], ["#ECF0F1", "#CED4D9", "#95A5A6", "#7E8C8D", "#34495E"], ["#000000", "#ffffff"]];

</script>